import { render, staticRenderFns } from "./PacInputNumber.vue?vue&type=template&id=5461b2ed&scoped=true"
import script from "./PacInputNumber.vue?vue&type=script&lang=ts"
export * from "./PacInputNumber.vue?vue&type=script&lang=ts"
import style0 from "./PacInputNumber.vue?vue&type=style&index=0&id=5461b2ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5461b2ed",
  null
  
)

export default component.exports